import { RapidGameDataServiceAPI } from '@API/gambyt-data-services/rapid-games-api'
import { DataFetchingState } from '@AppState/types'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

type LatestDrawState = {
  fetchState: DataFetchingState
  latestDraw: number | null
}

const initialState: LatestDrawState = {
  fetchState: DataFetchingState.IDLE,
  latestDraw: null,
}

export const fetchLatestDraw = createAsyncThunk('latest-draw/fetch', async () => {
  return await RapidGameDataServiceAPI.fetchLatestDrawNumber()
})

export const latestDrawSlice = createSlice({
  name: 'latest-draw',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchLatestDraw.fulfilled, (state, action) => {
      state.fetchState = DataFetchingState.SUCCEEDED
      state.latestDraw = action.payload
    })
    builder.addCase(fetchLatestDraw.pending, (state) => {
      state.fetchState = DataFetchingState.PENDING
    })
    builder.addCase(fetchLatestDraw.rejected, (state, action) => {
      console.error(action.error)
      state.fetchState = DataFetchingState.FAILED
    })
  },
})

export const LatestDrawActions = {
  ...latestDrawSlice.actions,
}

export const LatestDrawReducer = latestDrawSlice.reducer
